/**
 * IME (Input Method Editor) composition probe for keyboard handlers.
 *
 * Call `isImeComposing(event)` as the FIRST line of any handler that reacts to
 * Enter / Escape / letter keys, so CJK composition (candidate confirm, cancel,
 * letter keystrokes) never triggers an app action.
 *
 * `isComposing` alone misses some browser/IME sequences (e.g. the final Enter
 * that commits a composition in Safari), so the legacy keyCode 229 — the
 * "IME is processing this key" code — is kept as a compatibility probe.
 *
 * @param {KeyboardEvent|import('react').KeyboardEvent} event
 * @returns {boolean}
 */
export const isImeComposing = (event) =>
  event.isComposing ||
  event.nativeEvent?.isComposing ||
  event.keyCode === 229 ||
  event.nativeEvent?.keyCode === 229;
